import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { LoginWrapper } from "./styled";
import AuthSlider from "../../../components/auth/authSlider/AuthSlider";
import {
  AuthSlides,
  AuthSlidesAr,
} from "../../../helpers/authConstants/AuthConstants";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import ForgetPasswordModal from "./components/ForgetPasswordModal";
import EmailSentModal from "./components/EmailSentModal";
import { useLocation, useNavigate } from "react-router-dom";
import AuthApi from "../../../services/api/authApi";
import { AuthContext } from "../../../context/authContext";
import { toast } from "react-toastify";
import { emailRegex } from "../../../utils";
import { useUser } from "../../../context/userContext";

const Login = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status");
  const planType = queryParams.get("plan_type");

  const { t } = useTranslation();
  const { login } = useContext(AuthContext);
  const { fetchUserInfo } = useUser();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailSentModalShow, setEmailSentModalShow] = useState(false);

  const clearParams = () => {
    // Navigate to the same path without search params
    navigate(location.pathname, { replace: true });
  };

  const handleBtnClick = () => {
    setShowModal(false);
    setEmailSentModalShow(true);
  };

  useEffect(() => {
    if (status) {
      if (status === "CAPTURED") {
        if (planType === "private") {
          toast.success(t("payment_process_successful")); // you can customize this message
          clearParams();
        } else {
          toast.success(t("registered_successfully")); // you can customize this message
          clearParams();
        }
      } else if (status === "DECLINED") {
        toast.error(t("payment_failed")); // you can customize this message
        clearParams();
      }
    }
  }, [status]);

  const onSubmit = async (credentials) => {
    try {
      setLoading(true);
      const response = await AuthApi.login(credentials);
      if (response.code === 200) {
        if (response?.data?.access_token) {
          login(response?.data?.access_token);
          const user = await fetchUserInfo();
          toast.success(t("login_success"));
          if (user && Number(user?.user_type_id) === 6)
            navigate("/temporary-cabinets");
          else navigate("/dashboard");
        }
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
      if (response.code === 400) {
        toast.error(response.error);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginWrapper>
      <AuthHeader />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="mt-4 container-fluid pb-4">
          <Row>
            <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 overflow-y-auto">
              <Box className="mb-4">
                <HeadingStyled size="24px" weight="bold" color="var(--text)">
                  {t("wellcome_back")}
                </HeadingStyled>
                <TextStyled size="16px" color="var(--text2)">
                  {t("please_enter_email_password")}
                </TextStyled>
              </Box>
              <Box>
                <Box>
                  <ValidatedInput
                    name="email"
                    label={"email"}
                    type="input"
                    fieldType="text"
                    placeholder={"emailPlaceholder"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                      inline: true,
                      pattern: {
                        value: emailRegex,
                        message: "invalidEmail",
                      },
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                  <ValidatedInput
                    name="password"
                    label={"password"}
                    type="input"
                    fieldType="password"
                    placeholder={"passwordPlaceholder"}
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                      inline: true,
                      minLength: {
                        value: 8,
                        message: "lengthGreaterThen",
                      },
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                  <FormButtonStyled
                    label={t("login")}
                    color="var(--white)"
                    bg="var(--themeColor)"
                    className="w-100"
                    clName="w-100 my-4"
                    type="submit"
                    isLoading={loading}
                  />
                </Box>
                <Box className="d-flex justify-content-center justify-content-sm-end mb-3">
                  <Box>
                    <TextStyled
                      className="cursor-pointer"
                      color="var(--themeColor)"
                      size="16px"
                      weight="500"
                      onClick={() => setShowModal(true)}
                    >
                      {t("forgot_password")}
                    </TextStyled>
                  </Box>
                </Box>
                <Box>
                  <Box>
                    <TextStyled
                      className="justify-content-center align-items-center or-separator"
                      color="var(--text)"
                      size="16px"
                    >
                      {t("or")}
                    </TextStyled>
                  </Box>
                </Box>
                <FormButtonStyled
                  label={t("login_with_phone_num")}
                  color="var(--white)"
                  bg="var(--themeColor2)"
                  className="w-100"
                  clName="w-100 my-4"
                  onClick={() => navigate("/login-with-phone")}
                />
              </Box>
            </Col>
            <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 auth-slider">
              <Box className="sticky-item">
                <AuthSlider
                  slides={i18n.language === "en" ? AuthSlides : AuthSlidesAr}
                />
              </Box>
            </Col>
          </Row>
        </Box>
      </Form>
      <ForgetPasswordModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onBtnClick={handleBtnClick}
      />
      <EmailSentModal
        show={emailSentModalShow}
        onHide={() => setEmailSentModalShow(false)}
      />
    </LoginWrapper>
  );
};

export default Login;
